import React, { useEffect, useState } from 'react';
import axios from 'axios';
import TenderWiseLogo from '../../../Assets/logo/tenderwise-logo.png';
import BackgroundImage from '../../../Assets/images/SignupBackground.png';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import apiClient from './../../../Api/apiClient';

const ChangePassword = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordReTypeVisible, setPasswordReTypeVisible] = useState(false);
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);
  const [phone, setPhone] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [retypeNewPassword, setRetypeNewPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [passwordStrength, setPasswordStrength] = useState({
    minLength: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false,
  });
  const userType = localStorage.getItem('user_type');
  const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
  const toggleReTypePasswordVisibility = () =>
    setPasswordReTypeVisible(!passwordReTypeVisible);
  const toggleNewPasswordVisibility = () =>
    setNewPasswordVisible(!newPasswordVisible);

  const fetchProfileData = async () => {
    try {
      let url = '/user/profile';
      if (userType === 'affiliator') {
        url = '/affiliator/profile';
      }
      const response = await apiClient.get(url);
      // console.log('Profile Data:', response.data.data.phone);
      setPhone(response.data.data.phone);
    } catch (error) {
      console.error('Error fetching profile data:', error);
    }
  };

  useEffect(() => {
    fetchProfileData();
  }, []);

  const handleChangePassword = async e => {
    e.preventDefault();

    // Validate the inputs
    if (!phone || !currentPassword || !newPassword || !retypeNewPassword) {
      setErrorMessage('All fields are required.');
      return;
    }
    if (newPassword !== retypeNewPassword) {
      setErrorMessage('Passwords do not match.');
      return;
    }

    try {
      // Make the API call
      let url = '/auth/user/change-password';
      if (userType === 'affiliator') {
        url = '/affiliator/profile/change-password';
      }
      const response = await apiClient.patch(
        // '/auth/user/change-password',
        url,
        {
          phone,
          current_password: currentPassword,
          new_password: newPassword,
          retype_new_password: retypeNewPassword,
        }
      );
      // console.log('change password api response:', response.data);

      // Handle success
      setSuccessMessage('Password changed successfully!');
      setErrorMessage('');
      // Reset the form
      setPhone('');
      setCurrentPassword('');
      setNewPassword('');
      setRetypeNewPassword('');
    } catch (error) {
      console.log(error.response);
      // Handle error
      setErrorMessage(
        error.response?.data?.message || 'Failed to change password.'
      );
      setSuccessMessage('');
    }
  };

  // Validate Password Strength
  const handlePasswordChange = value => {
    setNewPassword(value);
    setPasswordStrength({
      minLength: value.length >= 8,
      uppercase: /[A-Z]/.test(value),
      lowercase: /[a-z]/.test(value),
      number: /\d/.test(value),
      specialChar: /[!@#$%^&*]/.test(value),
    });
  };

  return (
    <div
      className="flex flex-col items-center justify-center min-h-screen md:py-24 2xl:py-16 py-24 md:mt-10 mt-16 px-2"
      style={{ backgroundImage: `url(${BackgroundImage})` }}
    >
      {/* Header Section */}
      <div className="text-center mb-4">
        <img
          src={TenderWiseLogo}
          alt="TenderWise Logo"
          className="mx-auto mb-0"
        />
      </div>

      {/* Form Section */}
      <div className="bg-white border p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-xl font-bold text-center text-gray-800 mb-2">
          Reset Your Password
        </h2>
        <p className="text-sm text-center text-gray-500 mb-4">
          Please reset your new password which is unique
        </p>
        {errorMessage && (
          <p className="text-red-500 text-center text-sm mb-2">
            {errorMessage}
          </p>
        )}
        {successMessage && (
          <p className="text-green-500 text-center text-sm mb-2">
            {successMessage}
          </p>
        )}
        <form className="space-y-4" onSubmit={handleChangePassword}>
          {/* Phone Input */}
          {/* <div className="relative">
            <input
              type="text"
              placeholder="Phone Number"
              className="border text-xs border-gray-300 rounded-full py-2 px-4 w-full"
              value={phone}
              onChange={e => setPhone(e.target.value)}
            />
          </div> */}
          {/* Current Password */}
          <div className="relative">
            <input
              type={passwordVisible ? 'text' : 'password'}
              placeholder="Current Password"
              className="border text-xs border-gray-300 rounded-full py-2 px-4 w-full"
              value={currentPassword}
              onChange={e => setCurrentPassword(e.target.value)}
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none text-gray-500"
            >
              {passwordVisible ? <FaEye /> : <FaEyeSlash />}
            </button>
          </div>
          {/* New Password */}
          <div className="relative">
            <input
              type={newPasswordVisible ? 'text' : 'password'}
              placeholder="New Password"
              className="border text-xs border-gray-300 rounded-full py-2 px-4 w-full"
              value={newPassword}
              // onChange={e => setNewPassword(e.target.value)}
              onChange={e => handlePasswordChange(e.target.value)}
            />
            <button
              type="button"
              onClick={toggleNewPasswordVisibility}
              className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none text-gray-500"
            >
              {newPasswordVisible ? <FaEye /> : <FaEyeSlash />}
            </button>
            {/* Password Strength Checklist */}
            {newPassword && (
              <div className="mt-2 text-xs text-gray-600 space-y-1">
                <p
                  className={
                    passwordStrength.minLength
                      ? 'text-green-600'
                      : 'text-red-600'
                  }
                >
                  {passwordStrength.minLength
                    ? '✔ Use at least 8 characters'
                    : '✘ Use at least 8 characters'}
                </p>
                <p
                  className={
                    passwordStrength.uppercase
                      ? 'text-green-600'
                      : 'text-red-600'
                  }
                >
                  {passwordStrength.uppercase
                    ? '✔ Add at least one uppercase letter'
                    : '✘ Add at least one uppercase letter'}
                </p>
                <p
                  className={
                    passwordStrength.lowercase
                      ? 'text-green-600'
                      : 'text-red-600'
                  }
                >
                  {passwordStrength.lowercase
                    ? '✔ Add at least one lowercase letter'
                    : '✘ Add at least one lowercase letter'}
                </p>
                <p
                  className={
                    passwordStrength.number ? 'text-green-600' : 'text-red-600'
                  }
                >
                  {passwordStrength.number
                    ? '✔ Include at least one number'
                    : '✘ Include at least one number'}
                </p>
                <p
                  className={
                    passwordStrength.specialChar
                      ? 'text-green-600'
                      : 'text-red-600'
                  }
                >
                  {passwordStrength.specialChar
                    ? '✔ Include at least one special character'
                    : '✘ Include at least one special character'}
                </p>
              </div>
            )}
          </div>
          {/* Confirm Password */}
          <div className="relative">
            <input
              type={passwordReTypeVisible ? 'text' : 'password'}
              placeholder="Confirm Password"
              className="border text-xs border-gray-300 rounded-full py-2 px-4 w-full"
              value={retypeNewPassword}
              onChange={e => setRetypeNewPassword(e.target.value)}
            />
            <button
              type="button"
              onClick={toggleReTypePasswordVisibility}
              className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none text-gray-500"
            >
              {passwordReTypeVisible ? <FaEye /> : <FaEyeSlash />}
            </button>
          </div>
          {/* Buttons */}
          <div className="flex gap-2 justify-between mt-6 md:text-sm text-xs">
            <button
              type="button"
              className="md:px-4 px-2 py-2 border border-blue-500 text-blue-500 rounded-full hover:bg-blue-100 w-1/2"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="md:px-4 px-2 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600 w-1/2"
            >
              Change Password
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;

// import React, { useState } from 'react';
// import axios from 'axios';
// import TenderWiseLogo from '../../../Assets/logo/tenderwise-logo.png';
// import BackgroundImage from '../../../Assets/images/SignupBackground.png';
// import { FaEye, FaEyeSlash } from 'react-icons/fa';
// import apiClient from './../../../Api/apiClient';
// const ChangePassword = () => {
//   const [passwordVisible, setPasswordVisible] = useState(false);
//   const [passwordReTypeVisible, setPasswordReTypeVisible] = useState(false);
//   const [phone, setPhone] = useState('');
//   const [newPassword, setNewPassword] = useState('');
//   const [retypeNewPassword, setRetypeNewPassword] = useState('');
//   const [errorMessage, setErrorMessage] = useState('');
//   const [successMessage, setSuccessMessage] = useState('');

//   const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
//   const toggleReTypePasswordVisibility = () =>
//     setPasswordReTypeVisible(!passwordReTypeVisible);

//   const handleChangePassword = async e => {
//     e.preventDefault();

//     // Validate the inputs
//     if (!phone || !newPassword || !retypeNewPassword) {
//       setErrorMessage('All fields are required.');
//       return;
//     }
//     if (newPassword !== retypeNewPassword) {
//       setErrorMessage('Passwords do not match.');
//       return;
//     }

//     try {
//       // Make the API call
//       const response = await apiClient.patch(
//         '/auth/user/change-forget-password',
//         {
//           phone,
//           new_password: newPassword,
//           retype_new_password: retypeNewPassword,
//         }
//       );
//       console.log("change password api response :", response.data);

//       // Handle success
//       setSuccessMessage('Password changed successfully!');
//       setErrorMessage('');
//       // Reset the form
//       setPhone('');
//       setNewPassword('');
//       setRetypeNewPassword('');
//     } catch (error) {
//       console.log(error.response)
//       // Handle error
//       setErrorMessage(
//         error.response?.data?.message || 'Failed to change password.'
//       );
//       setSuccessMessage('');
//     }
//   };

//   return (
//     <div
//       className="flex flex-col items-center justify-center min-h-screen md:py-24 2xl:py-16 py-24 md:mt-10 mt-16 px-2"
//       style={{ backgroundImage: `url(${BackgroundImage})` }}
//     >
//       {/* Header Section */}
//       <div className="text-center mb-4">
//         <img
//           src={TenderWiseLogo}
//           alt="TenderWise Logo"
//           className="mx-auto mb-0"
//         />
//       </div>

//       {/* Form Section */}
//       <div className="bg-white border p-6 rounded-lg shadow-lg w-full max-w-md">
//         <h2 className="text-xl font-bold text-center text-gray-800 mb-2">
//           Reset Your Password
//         </h2>
//         <p className="text-sm text-center text-gray-500 mb-4">
//           Please reset your new password which is unique
//         </p>
//         {errorMessage && (
//           <p className="text-red-500 text-center text-sm mb-2">
//             {errorMessage}
//           </p>
//         )}
//         {successMessage && (
//           <p className="text-green-500 text-center text-sm mb-2">
//             {successMessage}
//           </p>
//         )}
//         <form className="space-y-4" onSubmit={handleChangePassword}>
//           {/* Phone Input */}
//           <div className="relative">
//             <input
//               type="text"
//               placeholder="Phone Number"
//               className="border text-xs border-gray-300 rounded-full py-2 px-4 w-full"
//               value={phone}
//               onChange={e => setPhone(e.target.value)}
//             />
//           </div>
//           {/* New Password */}
//           <div className="relative">
//             <input
//               type={passwordVisible ? 'text' : 'password'}
//               placeholder="New Password"
//               className="border text-xs border-gray-300 rounded-full py-2 px-4 w-full"
//               value={newPassword}
//               onChange={e => setNewPassword(e.target.value)}
//             />
//             <button
//               type="button"
//               onClick={togglePasswordVisibility}
//               className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none text-gray-500"
//             >
//               {passwordVisible ? <FaEyeSlash /> : <FaEye />}
//             </button>
//           </div>
//           {/* Confirm Password */}
//           <div className="relative">
//             <input
//               type={passwordReTypeVisible ? 'text' : 'password'}
//               placeholder="Retype New Password"
//               className="border text-xs border-gray-300 rounded-full py-2 px-4 w-full"
//               value={retypeNewPassword}
//               onChange={e => setRetypeNewPassword(e.target.value)}
//             />
//             <button
//               type="button"
//               onClick={toggleReTypePasswordVisibility}
//               className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none text-gray-500"
//             >
//               {passwordReTypeVisible ? <FaEyeSlash /> : <FaEye />}
//             </button>
//           </div>
//           {/* Buttons */}
//           <div className="flex gap-2 justify-between mt-6 md:text-sm text-xs">
//             <button
//               type="button"
//               className="md:px-4 px-2 py-2 border border-blue-500 text-blue-500 rounded-full hover:bg-blue-100 w-1/2"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className="md:px-4 px-2 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600 w-1/2"
//             >
//               Change Password
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ChangePassword;

// old
// import React, { useState } from 'react';
// import TenderWiseLogo from '../../../Assets/logo/tenderwise-logo.png';
// import BackgroundImage from '../../../Assets/images/SignupBackground.png';
// import { FaEye, FaEyeSlash } from 'react-icons/fa';
// import apiClient from './../../../Api/apiClient';
// const ChangePassword = () => {
//   const [passwordVisible, setPasswordVisible] = useState(false);
//   const [password, setPassword] = useState('');
//   const [passwordReTypeVisible, setPasswordReTypeVisible] = useState(false);
//     const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
//     const toggleReTypePasswordVisibility = () =>
//     setPasswordReTypeVisible(!passwordReTypeVisible);
//     const [ReTypepassword, setReTypepassword] = useState('');

//   return (
//     <div
//       className="flex flex-col items-center justify-center min-h-screen md:py-24 2xl:py-16 py-24 md:mt-10 mt-16 px-2"
//       style={{ backgroundImage: `url(${BackgroundImage})` }}
//     >
//       {/* Header Section */}
//       <div className="text-center mb-4">
//         <img
//           src={TenderWiseLogo}
//           alt="TenderWise Logo"
//           className="mx-auto mb-0"
//         />
//         {/* <p className="text-gray-600">
//           Reset your password to get access your account
//         </p> */}
//       </div>

//       {/* Form Section */}
//       <div className="bg-white border p-6 rounded-lg shadow-lg w-full max-w-md">
//         <h2 className="text-xl font-bold text-center text-gray-800 mb-2">
//           Reset Your Password
//         </h2>
//         <p className="text-sm text-center text-gray-500 mb-6">
//           Please reset your new password which is unique
//         </p>
//         <form className="space-y-4">
//           {/* Old Password */}
//           <div className="relative">
//             <input
//               type={passwordVisible ? 'text' : 'password'}
//               id="password"
//               placeholder="Old Password"
//               className="mt-1 block w-full border border-gray-300 rounded-full shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500 text-xs"
//               value={password}
//               // onChange={e => handlePasswordChange(e.target.value)}
//             />
//             <button
//               type="button"
//               className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500"
//               onClick={togglePasswordVisibility}
//             >
//               {passwordVisible ? <FaEyeSlash /> : <FaEye />}
//             </button>
//           </div>
//           {/* New Password */}
//           <div className="relative ">
//             <input
//               // type="password"
//               type={passwordReTypeVisible ? 'text' : 'password'}
//               placeholder="New Password"
//               className="border text-xs border-gray-300 rounded-full py-2 px-4 w-full"
//               value={ReTypepassword}
//               onChange={e => setReTypepassword(e.target.value)}
//             />
//             <button
//               type="button"
//               onClick={toggleReTypePasswordVisibility}
//               className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none text-gray-500"
//             >
//               {passwordReTypeVisible ? <FaEyeSlash /> : <FaEye />}
//             </button>
//           </div>
//           {/* Confirm Password */}
//           <div className="relative ">
//             <input
//               // type="password"
//               type={passwordReTypeVisible ? 'text' : 'password'}
//               placeholder="New Password"
//               className="border text-xs border-gray-300 rounded-full py-2 px-4 w-full"
//               value={ReTypepassword}
//               onChange={e => setReTypepassword(e.target.value)}
//             />
//             <button
//               type="button"
//               onClick={toggleReTypePasswordVisibility}
//               className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none text-gray-500"
//             >
//               {passwordReTypeVisible ? <FaEyeSlash /> : <FaEye />}
//             </button>
//           </div>
//           {/* Buttons */}
//           <div className="flex gap-2 justify-between mt-6 md:text-sm text-xs">
//             <button
//               type="button"
//               className="md:px-4 px-2 md:py-2 py-1 border border-blue-500 text-blue-500 rounded-full hover:bg-blue-100 w-1/2"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className="md:px-4 px-2 md:py-2 py-1 bg-blue-500 text-white rounded-full hover:bg-blue-600 w-1/2"
//             >
//               Change Password
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ChangePassword;
